import PropTypes from 'prop-types';
import { breakpoints, Button, Inline } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { AddOnOrder } from '@eti/types';
import { Envelope, Printer } from '@phosphor-icons/react';
import { useToggle } from '../../../common/custom-hooks/toggle';
import ReceiptPrintDialog from './modals/ReceiptPrintDialog';
import ReceiptMailDialog from './modals/ReceiptMailDialog';

const wrapperStyles = css`
  margin-top: 16px;
`;

const ReceiptConfirmationActions = ({
  addOnOrders,
  customerEmail,
  orderNumber,
  orderReferenceSerialized,
  purchaseDate,
}) => {
  const { t } = useTranslation();

  const {
    isOpen: isPrintConfirmationOpen,
    handleClose: handleClosePrintConfirmation,
    handleToggle: handleTogglePrintConfirmation,
  } = useToggle();

  const {
    isOpen: isMailDialogOpen,
    handleClose: handleCloseMailDialog,
    handleToggle: handleToggleMailDialog,
  } = useToggle();

  return (
    <>
      <Inline
        align="center"
        className={wrapperStyles}
        collapseBelow={breakpoints._970}
        spacing={16}
      >
        <Button
          data-testid="printConfirmation-button"
          iconPrefix={<Printer />}
          onClick={handleTogglePrintConfirmation}
        >
          {t('Receipt.ReceiptDetails.Label.PrintConfirmation')}
        </Button>
        <Button
          data-testid="mailConfirmation-button"
          iconPrefix={<Envelope />}
          onClick={handleToggleMailDialog}
        >
          {t('Receipt.ReceiptDetails.Label.MailConfirmation')}
        </Button>
      </Inline>
      <ReceiptPrintDialog
        addOnOrders={addOnOrders}
        isOpen={isPrintConfirmationOpen}
        onClose={handleClosePrintConfirmation}
        orderNumber={orderNumber}
        orderReferenceSerialized={orderReferenceSerialized}
        purchaseDate={purchaseDate}
      />
      <ReceiptMailDialog
        customerEmail={customerEmail}
        isOpen={isMailDialogOpen}
        onClose={handleCloseMailDialog}
        orderNumber={orderNumber}
      />
    </>
  );
};

ReceiptConfirmationActions.propTypes = {
  addOnOrders: PropTypes.arrayOf(AddOnOrder),
  customerEmail: PropTypes.string,
  orderNumber: PropTypes.string,
  orderReferenceSerialized: PropTypes.string,
  purchaseDate: PropTypes.string,
};

export default ReceiptConfirmationActions;
